import type { PluginWebManifest } from '@reflex/plugin-api/web';

export const linearWeb: PluginWebManifest = {
  orgSetupComponent: {
    componentPath: '@reflex/plugin-linear/web/LinearPage',
    label: 'Connect a Linear workspace and emit issue events to your automations.',
  },
  // Chip for the `linear_issue` association kind this plugin provides (see
  // `associationKinds` in the plugin definition): rendered wherever an
  // agent's linked work items show.
  associationChips: [
    {
      kind: 'linear_issue',
      label: 'Linear issue',
      componentPath: '@reflex/plugin-linear/web/LinearAssociationChip',
    },
  ],
  // `@linear:` category in the launch and chat composers. The server half is
  // the `linear-issue` resolver registered in `register()`.
  agentContextProviders: [
    {
      id: 'agent-context-linear-issues',
      kind: 'linear-issue',
      label: 'Linear tickets',
      keyword: 'linear',
      icon: 'ListTodo',
      componentPath: '@reflex/plugin-linear/web/LinearIssueContextProvider',
      order: 50,
    },
  ],
};
